import React from "react";
function numberWithCommas(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function yy_for_metric(current, last_year) {
  if (last_year <= 0 || current <= 0) {
    return "";
  }

  return ((current - last_year) / last_year) * 100;
}

function formatted_metric(opts) {
  if (!opts.value || opts.value == 0) return "";

  opts.metricName = opts.metricName.toLowerCase();

  if (opts.metricName.includes("roas")) {
    return "$" + numberWithCommas(opts.value.toFixed(2));
  } else if (opts.metricName.includes("revenue")) {
    return "$" + numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("spend")) {
    return "$" + numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("traffic")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("impressions")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("views")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("add_to_carts")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("earned_likes")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("earned_shares")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("checkouts_started")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("clicks")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("average_position")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("top_ten_keywords_percentage")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("top_ten_keywords")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("top_twenty_keywords")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("top_three_keywords")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("ctr")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("cart_to_conversion_rate")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("impression_to_cart_rate")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("social_view_rate")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("view_rate")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("bounce_rate")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("search_visibility")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("cpc")) {
    return "$" + numberWithCommas(opts.value.toFixed(2));
  } else if (opts.metricName.includes("conversions")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("conversion rate")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("cr")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("cvr")) {
    return numberWithCommas(opts.value.toFixed(2)) + "%";
  } else if (opts.metricName.includes("cpa")) {
    return "$" + numberWithCommas(opts.value.toFixed(2));
  } else if (opts.metricName.includes("cpv")) {
    return "$" + numberWithCommas(opts.value.toFixed(2));
  } else if (opts.metricName.includes("aov")) {
    return "$" + numberWithCommas(opts.value.toFixed(2));
  } else if (opts.metricName.includes("roas")) {
    return "$" + numberWithCommas(opts.value.toFixed(2));
  } else if (opts.metricName.includes("phone calls")) {
    return numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("cpm")) {
    return "$" + numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("gross margin")) {
    return "$" + numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("gross profit")) {
    return "$" + numberWithCommas(opts.value.toFixed(0));
  } else if (opts.metricName.includes("yy")) {
    return numberWithCommas(opts.value.toFixed(0)) + "%";
  } else {
    return "INVALID METRIC";
  }
}

class MetricTableRowOld extends React.Component {
  render() {
    let shouldRenderBottomBorder = this.props.rowNumber % 3 != 0;

    let yy = yy_for_metric(this.props.thisYearValue, this.props.lastYearValue);
    let firstValueClass = shouldRenderBottomBorder && !this.props.bottomRow ? "no-border" : "no-border-lrt";
    let secondValueClass = shouldRenderBottomBorder && !this.props.bottomRow ? "no-border" : "no-border-lrt";
    let thirdValueClass = "";

    if (typeof yy == "string" || yy >= 0) {
      if (typeof yy == "string") {
        thirdValueClass += "";
      } else if (this.props.metricName.includes === "cpa") {
        thirdValueClass += "yy-text-negative";
      } else {
        thirdValueClass += "yy-text-positive";
      }
    } else if (Number.isNaN(yy)) {
      thirdValueClass += "";
    } else if (this.props.metricName.includes("cpa")) {
      thirdValueClass += "yy-text-positive";
    } else {
      thirdValueClass += "yy-text-negative";
    }

    if (shouldRenderBottomBorder && !this.props.bottomRow) {
      thirdValueClass += " no-border-ltb";
    } else {
      thirdValueClass += " no-border-lt";
    }
    return (
      <React.Fragment>
        <td className={firstValueClass} > {formatted_metric({ metricName: this.props.metricName, value: this.props.lastYearValue })} </td>
        <td className={secondValueClass}> {formatted_metric({ metricName: this.props.metricName, value: this.props.thisYearValue })} </td>
        <td className={thirdValueClass}> {Number.isNaN(yy) ? "" : typeof yy == "string" ? "" : yy.toFixed(0).toString() + "%"} </td>
      </React.Fragment>
    );
  }
}

export default MetricTableRowOld;
